import request from '@/utils/request'

/**
 * 获取打印日志列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listShopPrinterLog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/printerMachine.listShopPrinterLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}